import React from "react";

interface ArticleListSkeletonProps {
  count?: number;
}

export const ArticleListSkeleton = ({
  count = 6,
}: ArticleListSkeletonProps) => {
  return (
    <div className="article-list-skeleton">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="article-skeleton-item">
          <div className="skeleton-header">
            <div className="skeleton-title"></div>
            <div className="skeleton-divider"></div>
            <div className="skeleton-product-icon"></div>
            <div className="skeleton-product-name"></div>
            <div className="skeleton-ux-tag"></div>
          </div>
          <div className="skeleton-content">
            <div className="skeleton-ux-tag-small"></div>
            <div className="skeleton-image-container">
              <div className="skeleton-image"></div>
            </div>
          </div>
          <div className="skeleton-author">
            <div className="skeleton-author-info">
              <div className="skeleton-author-label"></div>
              <div className="skeleton-author-name"></div>
            </div>
            <div className="skeleton-author-buttons">
              <div className="skeleton-button"></div>
              <div className="skeleton-button"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
